import basicApi from './modules/basic'
import authApi from './modules/auth'
import configApi from './modules/config'
import contactApi from './modules/contact'
import orderApi from './modules/order'
import productApi from './modules/product'
import crmApi from './modules/crm'
import ossApi from './modules/oss'
import corpApi from './modules/corp'
import thirdApi from './modules/third'
import etApi from './modules/et'

export default {
  basicApi,
  authApi,
  configApi,
  contactApi,
  orderApi,
  productApi,
  crmApi,
  ossApi,
  corpApi,
  thirdApi,
  etApi,
}
